import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class DateService {

    constructor(private cookieService: CookieService) {}

    public getCurrentLocale() {
        const locale = this.cookieService.get('locale');
        if (locale === 'en' || locale === 'fa') {
            return locale;
        } else {
            return environment.locale;
        }
    }
}
